/**
 * Veilige localStorage-wrapper (§19). Alle calls in try/catch; valt bij een
 * fout terug op een in-memory map zodat het spel nooit crasht. `opslagWerkt`
 * zegt of persistente opslag beschikbaar is (voor de "voortgang wordt niet
 * bewaard"-melding).
 */
type Tabel = Record<string, string>;
const geheugen: Tabel = {};

function testOpslag(): boolean {
  try {
    const k = '__ca_test__';
    localStorage.setItem(k, '1');
    localStorage.removeItem(k);
    return true;
  } catch {
    return false;
  }
}

export const opslagWerkt = typeof localStorage !== 'undefined' && testOpslag();

export const veiligeOpslag = {
  getItem(naam: string): string | null {
    try {
      if (opslagWerkt) return localStorage.getItem(naam);
    } catch {
      /* val terug */
    }
    return naam in geheugen ? geheugen[naam] : null;
  },
  setItem(naam: string, waarde: string): void {
    try {
      if (opslagWerkt) {
        localStorage.setItem(naam, waarde);
        return;
      }
    } catch {
      /* val terug */
    }
    geheugen[naam] = waarde;
  },
  removeItem(naam: string): void {
    try {
      if (opslagWerkt) {
        localStorage.removeItem(naam);
        return;
      }
    } catch {
      /* val terug */
    }
    delete geheugen[naam];
  },
};
